import React from 'react';
import GlobalFooter from '../GlobalFooter'
import Head_logo from '../../assets/images/head_logo.png'
import Form_logo from '../../assets/images/logo.png'
import './index.less';

export default class UserLayout extends React.Component {
    constructor() {
        super()
        this.state = {}
    }

    render() {
        return (
            <div className="user_layout_container">
                <div className="user_layout_header">
                    <img src={Head_logo} />
                </div>
                <div className="user_layout_content">
                    <div className="user_layout_content_top">
                        <div className="user_layout_top_content_logo">
                            <img src={Form_logo} />
                        </div>
                        <div className="user_layout_content_top_title">
                            <span>{this.props.title || '注册即可享受30天免费试用' }</span>
                        </div>
                    </div>
                    <div className="user_form">
                        {this.props.children}
                    </div>
                </div>
                <GlobalFooter />
            </div>
        )
    }
};